import { apiEndPoint } from "./endPoint";

interface NotificationDataForSave {
  userId: string;
  notificationTime: string;
}

export const putNotificationData = async (
  NotificationData: NotificationDataForSave,
  token: string
) => {
  const url = `${apiEndPoint}/putNotificationData`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(NotificationData),
    });

    if (response.ok) {
      const responseData = await response.json();
      console.log(response);
      return { ...responseData, status: 200 };
    } else {
      throw new Error("Failed to fetch");
    }
  } catch (err) {
    console.error("Error:", err);
    return {
      role: "error",
      content: "エラーが発生したようです。初めからやり直してください。",
    };
  }
};
